import React from "react";

export default function Home(props) {
  return (
    <div className="home-sectional">
      <div className="home-images"></div>
    </div>
  );
}
